/*jshint node:true*/

module.exports = require('./lib/jsonpath-object-transform.js');
